export const cookieBar = (() => {

    const $cookieBar = $('.cookie-bar');
    const $cookieBarBtn = $('.js-cookie-bar');


    $cookieBarBtn.on('click', function() {
        setCookie();
        checkCookie();
    });

    function getCookie() {
        var value = "; " + document.cookie;
        var parts = value.split("; " + 'cookieset' + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function setCookie() {
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = 'cookieset' + "=" + 'true' + ";" + expires + ";path=/";
    }

    function checkCookie() {
        let getCookieValue = getCookie();
        if (getCookieValue != 'true') {
            $cookieBar.removeClass('hidden');
        } else {
            $cookieBar.addClass('hidden');
        }
    }

    checkCookie();

})();


// WEBPACK FOOTER //
// ./src/components/cookie-bar/cookie-bar.js